export default "__VITE_ASSET__BVlukhk$__"